import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Moment from 'moment';
import SweetAlert from 'sweetalert-react';

import * as Utils from '../../../utils/utils';
import * as Orders from '../../../utils/ordersHelper';
import * as OrdersActions from '../../../actions/ordersActions';

class OrderListView extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeGroup: 'current',
      showAlert: false,
      swalParams: {
        title: ""
      }
    }

    this.renderOrders = this.renderOrders.bind(this);
    this.getOrderGroup = this.getOrderGroup.bind(this);
    this.exploreOrder = this.exploreOrder.bind(this);
  }

  componentDidMount() {

    this.props.dispatch(OrdersActions.getOrders(response => {
      if (!response.status) {
        this.setState({
          showAlert: true,
          swalParams: {
            title: "Failed to load order list, please try again later!",
            type: "error",
            showConfirmButton: false
          }
        })
        // setTimeout(() => this.setState({showAlert: false}), 2000);
      }
    }));
  }

  render() {

    console.log("ORDER_LIST_VIEW_PROPS", this.props);
    const { activeGroup, showAlert, swalParams } = this.state;
    return (
      <div className="page order-list-view">
        <div className="tabs-container">
          <div className={`tab ${activeGroup === 'upcoming'
            ? 'active'
            : ''}`} onClick={() => this.setState({ activeGroup: 'upcoming' })}>Upcoming Orders</div>
          <div className={`tab ${activeGroup === 'current'
            ? 'active'
            : ''}`} onClick={() => this.setState({ activeGroup: 'current' })}>Current Orders</div>
          <div className={`tab ${activeGroup === 'past'
            ? 'active'
            : ''}`} onClick={() => this.setState({ activeGroup: 'past' })}>Past Orders</div>
          <div className={`tab ${activeGroup === 'canceled'
            ? 'active'
            : ''}`} onClick={() => this.setState({ activeGroup: 'canceled' })}>Canceled Orders</div>
        </div>
        <div className="order-groups">
          {this.renderOrders()}
        </div>
        <SweetAlert customClass={"with-close"} showCancelButton cancelButtonText={"x"} onCancel={() => this.setState({ showAlert: false })} show={showAlert} {...swalParams} onConfirm={() => this.setState({ showAlert: false })} />
      </div>
    )
  }

  renderOrders() {

    const { activeGroup } = this.state;
    let orderGroup = this.getOrderGroup();
    let sortedOrders = orderGroup ? Orders.sortOrdersByCreatedAt(orderGroup, 'desc') : [];

    console.log("SORTED_ORDERS", sortedOrders);

    return sortedOrders && sortedOrders.length > 0
      ? (
        <div className="order-list">
          <div className="row list-header">
            <div className="col-lg-2 col-md-3 col-sm-3 status-col">Status</div>
            <div className="col-lg-2 col-md-9 col-md-2 col-sm-9 price-col">Total</div>
            <div className="col-lg-2 col-md-3 col-md-2 col-sm-3 date-col">Date</div>
            <div className="col-lg-6 col-md-9 col-sm-9 address-col">Address</div>
          </div>
          {sortedOrders.map((order, idx) => {
            return (
              <div className="row order" key={`${order.status}_order_${idx}`} onClick={() => this.exploreOrder(order)}>
                <div className="col-lg-2 col-md-4 col-sm-4 status-col">{order.status}</div>
                <div className="col-lg-2 col-md-8 col-md-2 col-sm-8 price-col">
                  <span className="title">{order.total
                    ? `$${order.total}`
                    : ''}</span>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-4 date-col">
                  <div className="sub-title">{order && order.deliveryStartTime
                    ? Moment(order.deliveryStartTime === 'now'
                      ? order.createdAt
                      : order.deliveryStartTime).format('ddd DD MMM YYYY')
                    : ''}</div>
                  <div className="description">{order && order.deliveryStartTime === 'now'
                    ? Moment(order.createdAt).format('hh:mma')
                    : order.deliveryStartTime ? Moment(order.deliveryStartTime).format('hh:mma') : ''}</div>
                </div>
                <div className="col-lg-5 col-md-8 col-sm-8 address-col">{order.address
                  ? order.address.apartment ? `Apartment #:${order.address.apartment}, ${order.address.description}` : order.address.description
                  : ''}</div>
                {order && order.giftDelivery ?
                  <div className="col-sm-12">
                    <span className="gift-delivery">GIFT DELIVERY</span>
                  </div>
                  : null
                }
              </div>
            )
          })}
        </div>
      )
      : (
        <div className="no-content">
          <div className="title">{`No ${Utils.toTitleCase(activeGroup)} Orders`}</div>
        </div>
      );
  }

  getOrderGroup() {

    const orders = Utils.toJS(this.props.orders);
    const { activeGroup } = this.state;

    let groupedOrders = orders
      ? Orders.groupOrders(orders)
      : [];
    switch (activeGroup) {
      case 'upcoming':
        return groupedOrders.upcomingOrders;
      case 'current':
        return groupedOrders.currentOrders;
      case 'past':
        return groupedOrders.pastOrders;
      case 'canceled':
        return groupedOrders.canceledOrders;
    }
  }

  exploreOrder(order) {

    this.props.history.push(`/orders/${order._id}`)
  }
}


export default connect((state) => {
  return {
    orders: state.getIn(['orders', 'orders'])
  };
})(OrderListView)



// WEBPACK FOOTER //
// ./src/containers/settings/orders/OrderListView.js